import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

const convex = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL as string);

const container = document.querySelector('#root') as HTMLElement;
const root = createRoot(container);
root.render(
  <ConvexProvider client={convex}>
    <App />
  </ConvexProvider>
);

// Report Web Vitals for performance monitoring
// You can pass a function to log results (e.g., to an analytics endpoint)
reportWebVitals(console.log);
